


















import {Component, Emit, Prop} from "vue-property-decorator";
import AsiDialogForm from "../common/AsiDialogForm.vue";
import AsiDialogFormLayout from "../common/AsiDialogFormLayout.vue";
import AsiTextField from "../common/AsiTextField";
import OrderCreate from "@/models/order/OrderCreate";
import CompanyAutocompleteInput from "@/components/company/CompanyAutocompleteInput.vue";
import CompanySimple from "@/models/company/CompanySimple";
import {AxiosError} from "axios";

@Component({
	components: {CompanyAutocompleteInput, AsiDialogFormLayout, AsiTextField}
})
export default class OrderCreateDialog extends AsiDialogForm {

	@Prop({type: Boolean, default: false})
	public noRedirectOnSave!: boolean;

	@Prop({type: Object, default: null})
	public company!: CompanySimple | null;

	private model: OrderCreate = new OrderCreate();

	public mounted(): void {
		this.initialize();
	}

	private initialize(): void {
		if (this.company) {
			this.model.companyId = this.company.id;
		}
	}

	@Emit('save')
	public save(event: Event): Event {
		this.initialize();
		return event;
	}

	@Emit('cancel')
	public cancel(event: Event): Event {
		const form = this.$refs.form as HTMLFormElement;
		this.reset([this.model], form);
		this.initialize();
		return event;
	}

	private requestSave(event: Event): void {
		this.loading = true;
		this.$orderService.create(this.model)
			.then(res => {
				if (!this.noRedirectOnSave) {
					this.$router.push({name: 'Order', params: {id: res.id}});
				}
				this.save(event);
			})
			.catch((err: AxiosError) => {
				this.errors = err.response?.data;
			})
			.finally(() => {
				this.loading = false;
			});
	}

}
